import { useCallback, useContext, useEffect, useMemo } from 'react';

import { useSurvey } from '@r1-frontend/survey';
import { surveyAnalytics } from '@r1-frontend/survey/analytics';
import { BECOME_CLIENT_SURVEY } from '@r1-frontend/survey/context/constants';
import { useCtxSelector as useSurveySelector } from '@r1-frontend/survey/context/hooks';
import { getDialogDetails } from '@r1-frontend/survey/context/selectors';

import PopupResult, { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';
import { Button } from '@r1-frontend/ui-kit/atoms/button';
import { SurveyBanner } from '@r1-frontend/ui-kit/molecules/Banner/Survey';

import { Ctx } from '~/src/components/ConnectDomruPopup/context';
import { setView } from '~/src/components/ConnectDomruPopup/context/actions';
import { useContextDispatch, useContextSelector } from '~/src/components/ConnectDomruPopup/context/hooks';
import { getResultStatus, selectResultMessage } from '~/src/components/ConnectDomruPopup/context/selectors';
import { getABNVariant } from '~/src/helpers/abn-tests';

const RequestResult = () => {
    const survey = useSurvey();

    const { showSurvey } = useContext(Ctx);

    const dispatch = useContextDispatch();

    const { status, message } = useContextSelector(state => ({
        status: getResultStatus(state),
        message: selectResultMessage(state),
    }));

    const isSurveyAvailable = useMemo(() => getABNVariant('feedback_context') === 'show_feedback_context', []);

    useEffect(() => {
        if (isSurveyAvailable) {
            survey.register(BECOME_CLIENT_SURVEY);
        }
    }, [isSurveyAvailable]);

    useEffect(() => {
        if (status === EResultPopupStatus.SUCCESS) {
            survey.show({ type: 'context', name: BECOME_CLIENT_SURVEY, inPopup: false });
        }
    }, [status]);

    const surveyDetails = useSurveySelector(getDialogDetails);

    const handleClose = () => {
        dispatch(setView('none'));
    };

    const handleStartSurvey = useCallback(() => {
        if (!surveyDetails) {
            return;
        }

        survey.markAsCompleted(surveyDetails.type, surveyDetails.name, surveyDetails.activeTo);
        surveyAnalytics.context.clickTakeSurvey();

        handleClose();
    }, [surveyDetails]);

    return (
        <PopupResult
            isOpen
            type={status}
            onClose={handleClose}
            {...message}
        >
            {(showSurvey && isSurveyAvailable && !survey.isComplete(BECOME_CLIENT_SURVEY) && surveyDetails)
                ? <SurveyBanner
                    image={surveyDetails.image}
                    title={surveyDetails.title}
                    description={surveyDetails.description}
                    buttonText={surveyDetails.buttonText}
                    linkProps={{
                        href: surveyDetails.externalLink,
                        target: '_blank',
                        rel: 'noopener',
                    }}
                    onClick={handleStartSurvey}
                />
                : <Button $type={'accent'} onClick={handleClose}>Закрыть</Button>
            }
        </PopupResult>
    );
};

export default RequestResult;
